import { render, staticRenderFns } from "./SGEventos3.vue?vue&type=template&id=05bf9a9c&scoped=true"
import script from "./SGEventos3.vue?vue&type=script&lang=js"
export * from "./SGEventos3.vue?vue&type=script&lang=js"
import style0 from "./SGEventos3.vue?vue&type=style&index=0&id=05bf9a9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bf9a9c",
  null
  
)

export default component.exports